exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bankNumber-container .table-list-mod[data-v-18c09473]{padding:10px 20px 10px 20px}.bankNumber-container .table-pagination[data-v-18c09473]{margin-top:0;padding:5px 20px 10px 20px}.bankNumber-container .table-pagination.fixed[data-v-18c09473]{padding:5px 20px;position:fixed;left:0;right:0;bottom:0;z-index:1002}", ""]);

// exports
